import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import {
  AppBar,
  Box,
  Toolbar,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import useAuth from "../../Utils/useAuth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faBars } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FooterContent } from "../../Utils/Constants.";
/**
//  * @component  layout wrap component to wrapped all component of page with 
//  * @description layout component having all menu list and user name.
//  * @returns layout UI
//  */
function LayoutComp({ children }) {
  /**
   * authentication function form uasAuth functional component
   */
  const { logout } = useAuth();
  const [userData, setUserData] = useState({});

  useEffect(() => {
    var data = JSON.parse(localStorage.getItem("userData"));
    setUserData(data);
  }, []);
  /**
   * theme provider to menu bar
   */
  const darkTheme = createTheme({
    palette: {
      primary: {
        main: "#493958",
      },
    },
  });

  const [state, setState] = useState({
    left: false,
  });

  /**
   *
   * @param {flag for toggle drawer} anchor
   * @param {*state of drawer} open
   * @returns
   */
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  /**
   *
   * @param {word which First Letter to be capitalize } string
   * @returns
   */
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   *
   * @param {*flag to list out drawer element for mobile} anchor
   * @returns
   */

  const list = (anchor) => (
    <Box
      className="drawerBox"
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 200 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List className="drawerList">
        <ListItem key={"Logo"} className="drawerListLogo">
          <img src="Images/logoADS.png" alt="logo" />
        </ListItem>
        <ListItem button key={"Username"}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faUserCircle} className="listItemIcon" />
          </ListItemIcon>
          <ListItemText primary={"Username"} className="listItemName" />
        </ListItem>
        <ListItem button key={"Zone"}>
          <ListItemIcon></ListItemIcon>
          <Link to="/home">
            <ListItemText primary={"Zone"} className="listItemName" />
          </Link>
        </ListItem>
        <ListItem button key={"Log out"} onClick={logout}>
          <ListItemIcon></ListItemIcon>
          <ListItemText primary={"Log out"} className="listItemName" />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <div className="layoutPage">
      <ThemeProvider theme={darkTheme}>
        <Box>
          <Box sx={{ flexGrow: 1, display: { xs: "none", sm: "flex" } }}>
            <AppBar position="static" className="layoutHeader">
              <Toolbar>
                <Box className="logoBox">
                  <img src="Images/adsLogo.png" alt="logo" />
                </Box>

                <MenuItem>
                  <Link to="/home">
                    <Box className="menuItem">Zone</Box>
                  </Link>
                </MenuItem>

                <Box sx={{ flexGrow: 1 }} />
                <Box className="menuItem">
                  <FontAwesomeIcon icon={faUserCircle} className="userIcon" />
                  {userData ? (
                    <span>
                      {userData &&
                        userData.firstName &&
                        capitalizeFirstLetter(userData.firstName)}
                      &nbsp;
                      {userData &&
                        userData.lastName &&
                        capitalizeFirstLetter(userData.lastName)}
                    </span>
                  ) : (
                    ""
                  )}
                </Box>
                <Box onClick={logout} className="menuItem logOutMenu">
                  Log out
                </Box>
              </Toolbar>
            </AppBar>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <AppBar position="static" className="layoutHeader">
              <Box sx={{ flexGrow: 1, display: "flex" }}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={toggleDrawer("left", true)}
                  color="inherit"
                >
                  <FontAwesomeIcon icon={faBars} className="menuIcon" />{" "}
                </IconButton>
                <img
                  src="Images/adsLogo.png"
                  alt="logo"
                  className="mobAdsLogo"
                />
                <Box className="menuItem mobileUserMenu">
                  <FontAwesomeIcon icon={faUserCircle} className="userIcon" />
                  {userData ? (
                    <span>
                      {userData &&
                        userData.firstName &&
                        capitalizeFirstLetter(userData.firstName)}
                      &nbsp;
                      {userData &&
                        userData.lastName &&
                        capitalizeFirstLetter(userData.lastName)}
                    </span>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
            </AppBar>
            <Drawer
              anchor={"left"}
              open={state["left"]}
              onClose={toggleDrawer("left", false)}
            >
              {list("left")}
            </Drawer>
          </Box>
        </Box>
      </ThemeProvider>
      <div className="mainContent">{children}</div>
      <footer>
        <FooterContent />
      </footer>
    </div>
  );
}

LayoutComp.propTypes = {
  children: PropTypes.element,
};

export default LayoutComp;
